// Stock photos in public/images/site (see CREDITS.md). Each one also has a
// 960px-wide "-960" copy, so phones don't download the full-size file.
import React from 'react';

const IMG = '/images/site';

const WIDTHS = {
  'airport-terminal': 1600,
  'app-phones': 1030,
  'cabin-skyline-view': 1536,
  'chauffeur-hands-wheel': 1600,
  'hero-manhattan-night': 1920,
  'leather-seat-detail': 1600,
  'manhattan-street-night': 1600,
  'night-ride-rear-seat': 1600,
  'route-atlantic-city-boardwalk': 1600,
  'route-boston-skyline': 1600,
  'route-greenwich-waterfront': 1600,
  'route-hamptons-beach': 1600,
  'route-new-haven-yale': 1600,
  'route-philadelphia-skyline': 1600,
  'route-ridgewood-dusk': 1600,
  'route-stamford-shore': 1600,
  'route-washington-capitol': 1600,
  'skyline-light-trails': 1920,
  'williamsburg-bridge-dusk': 1920,
};

// `sizes` values for the layouts the photos appear in.
export const FULL_WIDTH = '100vw';
export const CONTAINER_WIDTH = '(max-width: 1200px) 100vw, 1200px';
export const HALF_WIDTH = '(max-width: 960px) 100vw, 600px';
export const THIRD_WIDTH = '(max-width: 960px) 100vw, 400px';

// Spread onto an <img>: <img {...siteImage('airport-terminal', THIRD_WIDTH)} alt="" />
export function siteImage(name, sizes = FULL_WIDTH) {
  return {
    src: `${IMG}/${name}.webp`,
    srcSet: `${IMG}/${name}-960.webp 960w, ${IMG}/${name}.webp ${WIDTHS[name]}w`,
    sizes,
  };
}

// Phone widths, where heroes always get the 960px copy (a 3x phone would otherwise pick the full
// size). scripts/prerender.js preloads the hero with the same media queries.
export const PHONE_MEDIA = '(max-width: 768px)';

// The page's main photo (its Largest Contentful Paint): loaded first, 960px on phones.
export function HeroImage({ name }) {
  return (
    <picture>
      <source media={PHONE_MEDIA} srcSet={`${IMG}/${name}-960.webp`} />
      <img {...siteImage(name)} alt="" fetchpriority="high" />
    </picture>
  );
}
